<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <v-card class="box no-display">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Import Salary Master Details</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <a
                        href="https://eduplusschool.s3.ap-south-1.amazonaws.com/sample_csv_files/import_salary_master.csv">
                        <v-btn color="white" rounded outlined class="ma-2 downbtn">
                            Download CSV format
                            <v-icon right dark>mdi-cloud-download</v-icon>
                        </v-btn>
                    </a>
                </v-toolbar>
                <v-row justify="center" dense>
                    <center>Note: If you use the "Import Salary Master Details" option, only the amount of salary
                        component will be added, and the rule will not be included. The rule must be added manually
                        using the "Edit Salary Master" functionality.</center>
                </v-row>
                <v-row dense justify="center">
                    <v-col sm="4">
                        <v-file-input class="mt-2" dense placeholder="CSV of salary master details"
                            prepend-icon="mdi-file" label="Salary Master Details" show-size flat rounded outlined
                            v-model="file"></v-file-input>
                    </v-col>
                    <v-col sm="2">
                        <v-btn class="button" @click="submitFile()">Submit</v-btn>
                    </v-col>
                </v-row>
            </v-card>
            <v-card class="box" v-if="statuslist != ''">
                <v-toolbar dense flat color="white">
                    <v-radio-group class="mt-6" v-model="row" row>
                        <v-radio label="Success Records" value="success" color="success"
                            @click="row='success'"></v-radio>
                        <v-radio label="Failed Records" value="fail" color="error" @click="row='fail'"></v-radio>
                    </v-radio-group>
                </v-toolbar>
                <span v-if="row=='success'">
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Successful Records</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <br />
                    <v-data-table dense :headers="status_headers" :items="statuslist.statuslist[0].statuslist" sort-by
                        class="elevation-1 mytable" :search="search"></v-data-table>
                </span>
                <span v-if="row=='fail'">
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Failed Records</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <br />
                    <v-data-table dense :headers="status_headers" :items="statuslist.statuslist[0].faillist" sort-by
                        class="elevation-1 mytable" :search="search"></v-data-table>
                </span>
            </v-card>
            <v-card class="box no-display">
                <v-toolbar flat dense class="toolbar no-display">
                    <v-toolbar-title>Salary Master</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <br />
                <v-row justify="center" dense class="no-display">
                    <v-col cols="12" sm="4" md="4">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="employee_type"
                            :items="employee_type_list" item-text="name" item-value="id" label="Employee Type"
                            outlined />
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="designation"
                            :items="designation_list" item-text="name" item-value="id" label="Designation" outlined />
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="section" :items="section_list"
                            item-text="name" item-value="id" label="Employee Section" @change="getEmployeesBySection"
                            outlined persistent-hint hint="Please Select Employee Section" multiple />
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="employee" :items="employee_list"
                            item-text="name" item-value="id" label="Employee" outlined />
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-autocomplete rounded outlined dense v-model="pay_commision" :items="pay_commision_list"
                            item-text="name" item-value="id" label="Select Pay Commision" />
                    </v-col>
                    <!-- <v-col cols="12" sm="4" md="4">
                  <v-autocomplete rounded outlined dense v-model="sal_comp" @change="getSalaryRule(sal_comp)" :items="salary_component_list" item-text="s_d_name" item-value="s_id" label="Select Salary Component" />
              </v-col>
                <v-col cols="12" sm="4" md="4">
                  <v-autocomplete rounded outlined dense v-model="comp_rule" :items="component_rule" item-text="name" item-value="id" label="Select Salary Rule" />
              </v-col> -->
                    <v-btn @click="getEmpSalaryDetails()" :loading="loader" class="button">Fetch</v-btn>
                </v-row>
            </v-card>
            <v-card class="box" v-if="emp_salary_detail != ''">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Employee Salary Master Details</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row dense class="no-display">
                    <v-col cols="12" sm="2" md="2">
                        <v-btn class="ma-2 no-display" rounded color="success" outlined
                            @click="fnExcelReport('my-table-id', 'AllEmployeeSalaryMaster')" :loading="loader"><v-icon
                                color="success">mdi-export</v-icon>Export</v-btn>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-btn class="ma-2 no-display" rounded tile outlined color="warning" @click="print()"> <v-icon
                                class="mt-1 mb-1">mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>
                    </v-col>
                    <v-col cols="12" sm="4" md="4" class="pt-3">
                        <v-autocomplete clearable rounded outlined dense v-model="search" :items="comp_header"
                            item-text="name" label="Search Component" persistent-hint single-line></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-text-field v-model="search1" append-icon="mdi-magnify" label="Search Employee" single-line
                            hide-details></v-text-field>
                    </v-col>

                </v-row>
                <v-row dense justify="center" class="no-display" v-if="emp_salary_detail != ''">
                    <v-col cols="12" sm="12" md="12">
                    <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Add Rule to Component</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
            
                </v-toolbar>
                </v-col>
                     <v-col cols="12" sm="3" md="3" class="pt-2 mt-1">
                        <v-autocomplete clearable rounded outlined dense v-model="add_rule_comp" :items="comp_header"
                            item-text="name" item-value="s_id" label="Add Rule to Component" persistent-hint single-line></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-none mt-none" v-if="add_rule_comp">
                        <v-btn rounded class="button" @click="addRule(add_rule_comp,null)">Add Rule to component
                        </v-btn>
                    </v-col>
                   
                </v-row>
                 <v-row dense justify="center" class="no-display" v-if="emp_salary_detail != ''">
                     <v-col cols="12" sm="12" md="12">
                    <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Copy Salary Master</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
            
                </v-toolbar>
                </v-col>
                     <v-col cols="12" sm="3" md="3" class="pt-none mt-none">
                        <v-btn rounded class="button" :loading="copy_esm" @click="copySalaryMaster()">Copy Salary Master
                        </v-btn>
                    </v-col>
                 </v-row>
                <!-- <v-col cols="12" sm="12" md="12"> -->
                <div id="my-table-id" v-if="emp_salary_detail != ''">
                    <v-simple-table id="my-table-id1" fixed-header dense class="elevation-1 mytable"
                        :items-per-page="-1" v-if="emp_salary_detail != ''">
                        <thead class="toolbar">
                            <tr>
                                <th>
                                    <label class="form-checkbox">
                                        <input type="checkbox" v-model="selectAll" @click="select()" />
                                        <i class="form-icon"></i>
                                    </label>
                                </th>
                                <th align="center">Sr. No.</th>
                                <th class="hillbillyForm" align="center">Edit</th>
                                <th align="center">Employee</th>
                                <th align="center">Employee Type</th>
                                <th align="center">Revision No.</th>
                                <th align="center">Pay Commision</th>
                                <th align="center">From Date</th>
                                <th align="center">To Date</th>
                                <th align="center" v-for="(header, index) in filteredSortSearchList" :key="index">
                                    {{ header.name }}
                                </th>
                                <th align="center">Gross Earning</th>
                                <th align="center">Gross Deduction</th>
                                <th align="center">Net Salary</th>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- <tr v-for="(s, index) in emp_salary_detail" :key="index"> -->
                            <tr v-for="(s, index) in filteredItems" :key="s.emp_sal_id">
                                <td>
                                    <label class="form-checkbox">
                                        <input type="checkbox" :value="s.emp_sal_id" v-model="s.inst_flag" />
                                        <i class="form-icon"></i>
                                    </label>
                                </td>
                                <td align="">{{ index + 1 }}</td>
                                <td align="">
                                    <v-avatar style="" size="25" class="edit-avatar" @click="editItem(s.emp_sal_id)">
                                        <v-icon x-small class="edit-v-icon mr-2">edit</v-icon>
                                    </v-avatar>
                                </td>
                                <td align="">{{ s.emp_name }}</td>
                                <td align="">{{ s.emp_type }}</td>
                                <td align="">{{ s.emp_revision_no }}</td>
                                <td align="">{{ s.emp_pay_commision }}</td>
                                <td align="">{{ s.emp_fromdate }}</td>
                                <td align="">{{ s.emp_todate }}</td>
                                <td v-for="(header, index1) in filteredSortSearchList" :key="index1">
                                    <span v-for="comp in s.comp_value" :key="comp.emp_sd_id">
                                        <span v-if="header.name == comp.s_name">
                                            <center>
                                                {{ comp.s_value }}
                                                <br />
                                                <v-row dense justify="center" v-if="comp.is_rule_applicable == true">
                                                    <span v-if="
                            comp.is_rule_applicable == true && comp.rule_value
                          ">
                                                        <v-tooltip top color="black">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-icon size="20" v-bind="attrs" v-on="on"
                                                                    color="black">mdi-information</v-icon>
                                                            </template>
                                                            <span>
                                                                {{ comp.rule_value }}
                                                            </span>
                                                        </v-tooltip>
                                                        <v-tooltip top color="black">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-icon size="20" v-bind="attrs" v-on="on" color="red"
                                                                    @click="removeRule(comp.emp_sd_id)">mdi-filter-remove</v-icon>
                                                            </template>
                                                            <span> Remove Applied Rule </span>
                                                        </v-tooltip>
                                                    </span>
                                                    <span v-if="comp.is_rule_applicable == true">
                                                        <v-avatar style="" size="20" class="edit-avatar"
                                                            @click="addRule(comp.s_id, comp.emp_sd_id)">
                                                            <v-icon x-small class="edit-v-icon mr-2">edit</v-icon>
                                                        </v-avatar>
                                                    </span>
                                                </v-row>
                                            </center>
                                        </span>
                                    </span>
                                </td>
                                <td align="">{{ s.total_earn }}</td>
                                <td align="">{{ s.total_deduct }}</td>
                                <td align="">{{ s.net_sal }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </div>
                <!-- </v-col> -->
                <v-toolbar flat dense class="toolbar no-display">
                    <v-toolbar-title>Copy Employee Salary Details To Register</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <br />
                <v-row dense justify="center" class="no-display">
                    <v-col cols="12" sm="3" md="3" class="pt-1 mt-1">
                        <v-autocomplete class="no-display" color="#0F2027" multiple dense rounded required
                            v-model="inst_reg_copy" :items="inst_list" item-text="name" item-value="id" label="Employee"
                            outlined />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="mt-2">
                        <v-autocomplete dense rounded outlined v-model="sal_month" :items="salary_month_detail"
                            color="#0F2027" item-text="name" item-value="id" label="Select Salary Month"
                            single-line></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-none mt-none">
                        <v-btn rounded class="button" :loading="copy_esm" @click="copySalaryMasterToRegister">Copy
                            Salary To Register</v-btn>
                    </v-col>
                </v-row>
            </v-card>
            <v-dialog v-model="dialog_edit_rule" persistent max-width="1200px">
                <v-card>
                    <v-toolbar class="toolbar" flat dense>
                        <v-toolbar-title>
                            <strong> Add Rule </strong>
                        </v-toolbar-title>
                    </v-toolbar>
                    <center>
                        <v-col cols="12" sm="6" md="6">
                            <v-autocomplete dense rounded outlined v-model="comp_rule_edit" :items="component_rule_edit"
                                color="#0F2027" item-text="name" return-object label="Rule"
                                single-line></v-autocomplete>
                        </v-col>
                    </center>
                    <v-row justify="center">
                        <v-btn rounded class="button" @click="addrule_edit(comp_rule_edit)" :loading="loading_add_rule">Save</v-btn>
                        <v-btn rounded class="button" @click="dialog_edit_rule = false">Close</v-btn>
                    </v-row>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialog_edit" fullscreen>
                <v-card>
                    <v-col cols="12" sm="12" md="12">
                        <edit-employee-salary-master :emp_sal_id="emp_sal_id" :edit_flag="edit_flag"
                            @changedialog="chnaged($event)"></edit-employee-salary-master>
                    </v-col>
                    <v-row justify="center" dense>
                        <v-btn class="button mt-3" @click="dialog_edit = false">Cancel</v-btn>
                    </v-row>
                </v-card>
            </v-dialog>

        </v-container>
    </div>
    <!-- /. root div -->
</template>
<script>
  import axios from "axios";
  import html2pdf from "html2pdf.js";
  import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import EditEmployeeSalaryMaster from "./EditEmployeeSalaryMaster";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
  export default {
      components: {
          "edit-employee-salary-master": EditEmployeeSalaryMaster,
          Breadcrumbs
      },
      data: () => ({
        row: "success",
          file:null,
          loader: false,
        //   extraBreadcrumbItems: [
           

        //   ],
        //   breadcrumbClass: "breadcrumb-style1",
          snackbar_msg: "",
          color: "",
          snackbar: false,
          title: "",
          description: "",
          sal_month_list: [],
          employee_type_list: [],
          employee_list: [],
          designation_list: [],
          pay_commision_list: [],
          salary_component_list: [],
          component_rule: [],
          component_rule_edit: [],
          comp_rule_edit: null,
          comp_rule: null,
          pay_commision: null,
          sal_comp: "",
          employee_type: null,
          employee: null,
          designation: null,
          comp_header: [],
          emp_salary_detail: [],
          dialog_edit_rule: false,
          dialog_edit: false,
          edit_flag: null,
          emp_sal_id: null,
          search: null,
          emp_sd_id: null,
          loading_add_rule:false,
          salary_month_detail: [],
          sal_month: null,
          search1: "",
          inst_list: null,
          inst_reg_copy: [],
          copy_esm: false,
          singleSelect: false,
          selectedTasks: [],
          selectAll:false,
          selected_inst_id:[],
          overlay: false,
          statuslist: [],
          add_rule_comp:null,
          status_headers: [
                {
                    text: "Employee Code",
                    value: "employeecode",
                },
                {
                    text: "Reason",
                    align: "left",
                    sortable: true,
                    value: "status",
                },
            ],
            section_list: [],
            section: null
      }),
      watch: {
            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
        },
      computed: {
          filteredItems() {
              return this.emp_salary_detail.filter((item) => {
                  return (
                      item.emp_name.toLowerCase().indexOf(this.search1.toLowerCase()) > -1 ||
                      item.emp_type.toLowerCase().indexOf(this.search1.toLowerCase()) > -1 ||
                      item.emp_pay_commision.toLowerCase().indexOf(this.search1.toLowerCase()) > -1 ||
                      item.emp_fromdate.toLowerCase().indexOf(this.search1.toLowerCase()) > -1 ||
                      item.emp_todate.toLowerCase().indexOf(this.search1.toLowerCase()) > -1
                  );
              });
          },
          filteredSortSearchList() {
              function compare(a, b) {
                  if (a.name < b.name) return -1;
                  if (a.name > b.name) return 1;
                  return 0;
              }
              if (!this.search) return this.comp_header.sort(compare);
              return this.comp_header.filter((tbdata) => {
                  return tbdata.name.toLowerCase().indexOf(this.search.toLowerCase()) >= 0;
              });
          },
      },
      methods: {
        getEmployeesBySection() {
                const data = {
                    section_id: this.section,
                };
                axios
                    .post("/Payroll/getEmployeesBySection", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.employee_list = res.data.employee_list;
                        } else {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {});
        },
        submitFile() {
                if (this.file == null) {
                    alert("Please select the file!");
                } else {
                    this.overlay = true;
                    let formData = new FormData();
                    formData.append("file", this.file);

                    //console.log(formData)
                    axios
                        .post("Payroll/importemployeemonthlysalarymaster", formData, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                            },
                        })
                        .then((res) => {
                            if (res.data.status == "NO") {
                                this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
                            } else {
                                this.statuslist = res.data;
                                // console.log(res.data.statuslist)
                                // this.failed_record_list = res.datastatuslist.statuslist[0].faillist.;
                                
                                this.overlay = false;
                                this.row = "success";
                                this.showSnackbar("#4caf50", "Data Imported Successfully..."); // show snackbar on success
                            }
                        })
                        .catch(function () {
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        })
                        .finally(() => {
                            this.overlay = false;
                            this.file = null;
                        });
                    //     }
                }
            },
          print() {
              this.$store.state.drawer = false;
              let that = this;
              window.onafterprint = function () {
                  that.$store.state.drawer = true;
              };
              setTimeout(function () {
                  window.print();
              }, 100);
          },
          fnExcelReport(id, name) {
              var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
              tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
              tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
              tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
              tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
              tab_text = tab_text + "<table border='1px'>";
              var exportTable = $("#" + id).clone();
              exportTable.find("input").each(function (index, elem) {
                  $(elem).remove();
              });

              tab_text = tab_text + exportTable.html();
              tab_text = tab_text + "</table></body></html>";
              var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

              //Save the file
              // var blob = new Blob([tab_text], {
              //   type: "application/vnd.ms-excel;charset=utf-8",
              // });
              // window.saveAs(blob, fileName);
              const blob = new Blob([tab_text], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
              const filename = name + ".xls";

              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                  // For IE
                  window.navigator.msSaveOrOpenBlob(blob, filename);
              } else {
                  // For modern browsers
                  const url = window.URL.createObjectURL(blob);
                  const a = document.createElement("a");
                  a.href = url;
                  a.download = filename;
                  a.click();
                  window.URL.revokeObjectURL(url);
              }
          },

          exportToPDF() {
              html2pdf(document.getElementById("my-table-id1"), {
                  // margin: 1,
                  filename: "i-was-html.pdf",
                  // html2canvas: { scale: 1, useCORS: true },
                  marginLeft: 5,
                  jsPDF: {
                      unit: "in",
                      format: "a3",

                      // width: 20,
                      // height: 17,
                      //   page_size: "16 17",
                      orientation: "landscape",
                  },
              });
          },
          copySalaryMasterToRegister() {
              const data = {
                  sal_month: this.sal_month,
                  employee: this.inst_reg_copy,
                  //    emp_salary_detail: this.emp_salary_detail,
              };
              this.copy_esm = true;
              axios
                  .post("/Payroll/copySalaryMasterToRegister", data)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.showSnackbar("#4caf50", "Salary Copied Successfully...");
                          this.getEmpSalaryDetails();
                          this.copy_esm = false;
                      } else {
                          this.showSnackbar("#b71c1c", "Something went wrong!!!");
                          sessionStorage.setItem("error-trace", res.data.error_trace);
                          this.copy_esm = false;
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something Went Wrong");
                      this.copy_esm = false;
                      this.inst_reg_copy = [];
                  });
          },
          copySalaryMaster() {
            this.selected_inst_id = [];
                for (let i in this.emp_salary_detail) {
                    if (this.emp_salary_detail[i].inst_flag == true) {
                        this.selected_inst_id.push(this.emp_salary_detail[i].emp_sal_id);
                    }
                }
                if (!confirm("Selected Employee :: " + this.selected_inst_id.length + ". Want to proceed...?")) return;
              const data = {
                selected: this.selected_inst_id,
              };
              this.copy_esm = true;
              axios
                  .post("/Payroll/copySalaryMaster", data)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.showSnackbar("#4caf50", "Salary Copied Successfully...");
                          this.getEmpSalaryDetails();
                          this.copy_esm = false;
                      } else {
                          this.showSnackbar("#b71c1c", "Something went wrong!!!");
                          sessionStorage.setItem("error-trace", res.data.error_trace);
                          this.copy_esm = false;
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something Went Wrong");
                      this.copy_esm = false;
                      this.inst_reg_copy = [];
                  });
          },
          select() {
                this.selected = [];
                for (let i in this.emp_salary_detail) {
                    this.emp_salary_detail[i].inst_flag = false;
                }
                if (!this.selectAll) {
                    for (let i in this.emp_salary_detail) {
                        this.selected.push(this.emp_salary_detail[i].emp_sal_id);
                        this.emp_salary_detail[i].inst_flag = true;
                    }
                }
            },
          getEmpSalaryDetails() {
              const data = {
                  pay_commision: this.pay_commision,
                  employee_type: this.employee_type,
                  designation: this.designation,
                  employee: this.employee,
                  section: this.section,
              };
              this.loader = true;
              axios
                  .post("/Payroll/getEmpSalaryDetails", data)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.emp_salary_detail = res.data.emp_salary_detail;
                          this.comp_header = res.data.comp_header;
                          this.salary_month_detail = res.data.salary_month_detail;
                          this.loader = false;
                      } else {
                          this.showSnackbar("#b71c1c", "Something went wrong!!!");
                          sessionStorage.setItem("error-trace", res.data.error_trace);
                          this.loader = false;
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something Went Wrong");
                      this.loader = false;
                  });
          },
          removeRule(emp_sd_id) {
              const data = {
                  emp_sd_id: emp_sd_id,
                  comp_rule_edit: null,
              };
              axios
                  .post("/Payroll/UpdateSalaryRule", data)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.showSnackbar("#4caf50", "Salary Rule Deleted Successfully...");
                          this.getEmpSalaryDetails();
                      } else {
                          this.showSnackbar("#b71c1c", "Something went wrong!!!");
                          sessionStorage.setItem("error-trace", res.data.error_trace);
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something Went Wrong");
                      this.dialog_edit_rule = false;
                  });
          },
          addrule_edit(comp_rule_edit) {
            this.loading_add_rule = true;
            if(this.emp_sd_id == null){
              this.selected_inst_id = [];
                for (let i in this.emp_salary_detail) {
                    if (this.emp_salary_detail[i].inst_flag == true) {
                        for (let j in this.emp_salary_detail[i].comp_value) {
                            const comp = this.emp_salary_detail[i].comp_value[j];
                            if(comp_rule_edit.salarycomponent_id == comp.s_id){
                                this.selected_inst_id.push(comp.emp_sd_id);
                            }
                        }
                    }
                }
                this.emp_sd_id = this.selected_inst_id
                if (!confirm("Selected Employee :: " + this.selected_inst_id.length + ". Want to proceed...?")) return;
            }
              const data = {
                  emp_sd_id: this.emp_sd_id,
                  comp_rule_edit: comp_rule_edit,
                 // selected: this.selected_inst_id,
              };
              axios
                  .post("/Payroll/UpdateSalaryRule", data)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.dialog_edit_rule = false;
                          this.showSnackbar("#4caf50", "Salary Rule Updated Successfully...");
                          this.loading_add_rule = false;
                          this.getEmpSalaryDetails();
                      } else {
                          this.showSnackbar("#b71c1c", "Something went wrong!!!");
                          sessionStorage.setItem("error-trace", res.data.error_trace);
                          this.dialog_edit_rule = false;
                          this.loading_add_rule = false;
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something Went Wrong");
                      this.dialog_edit_rule = false;
                      this.loading_add_rule = false;
                      this.comp_rule_edit = null;
                      this.selected_inst_id = [];
                  });
          },
          editItem(emp_sal_id) {
              this.emp_sal_id = emp_sal_id;
              this.edit_flag = "yes";
              this.dialog_edit = true;
          },
          chnaged(dialog) {
              this.dialog_edit = dialog;
              this.getEmpSalaryDetails();
          },
          addRule(sid, emp_sd_id) {
              this.emp_sd_id = emp_sd_id;
              const data = {
                  sid: sid,
              };
              axios
                  .post("/Payroll/addComponentRule", data)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.component_rule_edit = res.data.component_rule;
                          this.dialog_edit_rule = true;
                      } else if (res.data.flag == "NO") {
                         this.showSnackbar("#b71c1c", res.data.flag_msg)
                      }else {
                          this.showSnackbar("#b71c1c", "Something went wrong!!!");
                          sessionStorage.setItem("error-trace", res.data.error_trace);
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something Went Wrong");
                  });
          },
          getSalaryRule(sal_comp) {
              const data = {
                  sid: sal_comp,
              };
              axios
                  .post("/Payroll/getSalaryRule", data)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.component_rule = res.data.component_rule;
                      } else {
                          this.showSnackbar("#b71c1c", "Something went wrong!!!");
                          sessionStorage.setItem("error-trace", res.data.error_trace);
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something Went Wrong");
                  });
          },
          onLoad() {
              axios
                  .post("/Payroll/allEmployeeSalaryMasterInfo")
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.employee_type_list = res.data.employee_type_list;
                          this.employee_list = res.data.employee_list;
                          this.designation_list = res.data.designation_list;
                          this.salary_component_list = res.data.salary_component_list;
                          this.pay_commision_list = res.data.pay_commision_list;
                          this.inst_list = res.data.inst_list;
                          this.section_list = res.data.section_list;
                      } else {
                          this.showSnackbar("#b71c1c", "Something went wrong!!!");
                          sessionStorage.setItem("error-trace", res.data.error_trace);
                      }
                  })
                  .catch((error) => {
                      window.console.log(error);
                  })
                  .finally(() => {});
          },

          showSnackbar(clr, msg) {
              this.snackbar = true;
              this.color = clr;
              this.snackbar_msg = msg;
          },
      },
      mounted() {
          this.onLoad();
      },
  };
</script>
<style scoped>
  /* .v-text-field{
    width: 80px;
} */
  thead {
      font-weight: bold !important;
  }
  th {
      font-weight: bold !important;
  }
  tr,
  td,
  th {
      border: 1px solid black;
      /* text-align: center; */
      font-size: small;
  }
  tr,
  tbody {
      border-bottom: 1px solid black;
      border: 1px solid black;
      font-size: small;
  }
  td {
      font-size: small;
  }
  @media (min-width: 320px) {
      td,
      th {
          display: table-cell !important;
          font-size: small;
      }
      td + td,
      th + th {
          width: auto;
          font-size: small;
      }
  }
  v-simple-table {
      white-space: nowrap !important;
      /* text-align: center; */
      font-size: small;
  }

  .edit-avatar {
      transition: 0.3s;
      border: 1px solid #b0bec5;
  }
  .edit-avatar:hover {
      background-color: #b0bec5;
  }
  .edit-v-icon {
      padding-left: 6px;
      font-size: 15px;
  }
  .edit-v-icon:hover {
      color: white;
  }
  @media print {
      header,
      footer,
      nav,
      date {
          display: none !important;
      }

      table,
      td,
      tr {
          break-inside: avoid-page;
      }

      /* img {
  width: 100% !important;
} */
      .scroll {
          overflow-x: hidden;
      }

      body,
      tr,
      th,
      td,
      center {
          font-size: 14pt !important;
          font-weight: bold !important;
      }

      .no-display,
      .v-input__control,
      input[type="button"],
      input[type="submit"],
      input[type="reset"],
      #v-card {
          display: none !important;
      }

      v-card {
          border: none !important;
      }

      .trust-logo {
          width: 86%;
      }

      .schl-logo {
          width: 83%;
      }

      @page {
          size: A4;
          margin-top: none !important;
          padding-top: none;
          size: 35.5in 18.5in;
      }

      .table-data {
          height: 100% !important;
          overflow-x: hidden;
          overflow-y: hidden;
      }

      .box {
          /* height: 100% !important; */
          overflow-x: hidden;
          border: none !important;
      }
  }
</style>
<!-- abcd-->
